<template>
  <div
    class="xl:w-4/5 md:w-11/12 xl:my-10 md:my-4
     md:mx-auto m-1 bg-gray-50 rounded"
  >
    <EditForm
      :row="Array(headings.length)"
      :headers="headings"
      :values="{ prog_code: this.course_titles }"
      :submitEdit="submitEdit"
      :hide="editHideColumns"
      v-if="show"
    />

    <div class="flex flex-row justify-center p-4 w-full">
      <div class="flex ml-auto">
        <div>
          <h1 class="font-semibold xl:text-xl ">Manage LDAP Overrides</h1>
        </div>
      </div>
      <t-button
        variant="success"
        class="float-right ml-auto"
        @click="show = true"
        >Insert New Record</t-button
      >
      <br />
    </div>
    <div class="flex">
      <Table
        :items="items"
        :values="{ prog_code: this.course_titles }"
        :editHideColumns="editHideColumns"
        :del="del"
        :getTheDataInParent="getTheData"
        :edit="edit"/>
    </div>
  </div>
</template>

<script>
import Table from './Table';
import EditForm from './EditForm';

export default {
  components: {
    Table,
    EditForm,
  },
  mounted() {
    this.getTheData();
  },
  methods: {
    handleSelected(event) {
      this.selectedYear =
        event.target.options[event.target.options.selectedIndex].text;
      this.getTheData();
    },
    async getTheData() {
      const ldap_res = await fetch(
        `${process.env.VUE_APP_API_URL}/get_ldap_overrides`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      const ldap_ret = await ldap_res.json();
      if (!ldap_ret.success) {
        throw ldap_res.error;
      }

      this.items = await ldap_ret.data;

      const course_res = await fetch(
        `${process.env.VUE_APP_API_URL}/get_course_titles`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      const course_ret = await course_res.json();
      if (!course_ret.success) {
        throw coures_res.error;
      }

      const titles = await course_ret.data
      this.course_titles = titles.sort(
        (p1, p2) => p1.title.localeCompare(p2.title)
      ).map(
        course => [course.prog_code, course.title]
      )
    },

    async del(row) {
      const res = await fetch(
        `${process.env.VUE_APP_API_URL}/delete_ldap_override`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: row[0],
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    submitEdit(edit) {
      if (edit === 'cancel') {
        this.show = false;
        return;
      }

      this.show = false;

      this.insert(edit).then((res) => {
        if (res.ok) {
          console.log(res);
          this.$vToastify.success('Successfully carried out edit');
          this.getTheData();
        } else {
          this.$vToastify.error('Could not edit, see console for details');
          console.error(res);
        }
      });
    },

    async edit(oldRow, newRow) {
      return this.insert(newRow)
    },

    async insert(edit) {
      const res = fetch(
        `${process.env.VUE_APP_API_URL}/insert_ldap_override`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: edit[0],
            prog_code: edit[1],
            stage: edit[3],
            comment: edit[4],
            jwt: localStorage.getItem('jwt'),
          }),
        },
      );
      return await res;
    },

    setCookie() {
      this.$cookies.set('ManageLeaders-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('ManageLeaders-infobox') === 'dismissed');
    },
  },
  data() {
    return {
      headings: ["email", "prog_code", "title", "stage", "comment"],
      editHideColumns: new Set(["title"]),
      show: false,
      items: [],
      course_titles: [],
    };
  },
};
</script>

<style></style>
